import { render, staticRenderFns } from "./Navegacion.vue?vue&type=template&id=07d8a061&scoped=true&"
import script from "./Navegacion.vue?vue&type=script&lang=js&"
export * from "./Navegacion.vue?vue&type=script&lang=js&"
import style0 from "./Navegacion.vue?vue&type=style&index=0&id=07d8a061&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d8a061",
  null
  
)

export default component.exports